import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DefaultToggleButtonGroup from "../DefaultToggleButtonGroup";
import { trackUserInteraction } from "@/services/analytics-adapter";

interface Props {
  data?: { value: unknown } | null;
  onChange?: (data: any) => void;
}

const getValueFromDataProp = (value: string | undefined) => {
  if (value === "M" || value?.toUpperCase() === "MALE") {
    return "Male";
  } else if (value === "F" || value?.toUpperCase() === "FEMALE") {
    return "Female";
  }

  return null;
};

export default function QuestionTypeSexAtBirth(props: Props) {
  const { t } = useTranslation();

  const [internalValue, setInternalValue] = useState<string | null>(null);

  const options = [
    {
      name: t("common.male"),
      value: "Male",
    },
    {
      name: t("common.female"),
      value: "Female",
    },
  ];

  useEffect(() => {
    setInternalValue(getValueFromDataProp(props?.data?.value as string));
  }, [props?.data]);

  useEffect(() => {
    if (props.onChange) {
      props.onChange({
        data: { value: internalValue },
        isValid: internalValue !== null,
      });
    }
  }, [internalValue]);

  function onToggleButtonChange(_event: any, value: string) {
    setInternalValue(value);
    trackUserInteraction({
      linkText: `Edit Sex at birth | ${internalValue}`,
      linkIntent: "confirmational",
      linkScope: "button",
    });
  }

  return (
    <Stack spacing={2} justifyContent="space-between">
      <Stack spacing={4}>
        <Typography variant="h3">
          {t("QuestionTypeSexAtBirth.title")}
        </Typography>
        <DefaultToggleButtonGroup
          options={options}
          value={internalValue}
          onChange={onToggleButtonChange}
          fullWidth
          exclusive
          color="neutralTransparent"
        />
      </Stack>
    </Stack>
  );
}
